export default {
  customer_page: {
    message: {
      created: "Created",
      updated: "Updated",
      deleted: "Deleted",
    },
  },
  cart_page: {
    messsage: {
      remove_cart_item: "製品をカートから削除します",
      removed_cart_item: "削除しました",
      empty_cart: "カートに商品を追加してください",
      remove_cart: "Are you sure",
      removed_cart: "The cart has been deleted!",
      cart_notfound: "The cart not found",
      quantity_is_required: "数量は必ず指定してください",
      order_limit_to_cart:
        "注文上限（96製品）を超えているため、カートに追加できません",
      delete_message:
        "{item_name_1} {item_name_2}（{item_code}）を削除します。この操作は取り消せません",
      title_popup_delete: "製品の削除",
      title_popup_delete_order: "注文製品の削除",
    },
    validate: {
      max_price: "注文可能な金額を超えています",
    },
  },
  cart_delivery_page: {
    messsage: {
      prodction_was_deleted: "Have a production was deleted!",
      has_errors: "Please check again",
      empty_delivery_address: "Please add delivery address",
    },
  },
  product_page: {
    messsage: {
      created: "作成しました",
      updated: "更新しました",
      deleted: "削除しました",
    },
  },
  order_history_page: {
    messsage: {
      print_pdf_success: "納品書を発行いたしました",
    },
  },
  download_files: {
    order_history: "{filename}_納品書.pdf",
  },
  no_result: "該当データは見つかりませんでした",
  no_result_sales_bom: "製品が登録されていません。",
  no_result_products: "該当商品がありません",
  error: "Internal error",
  un_selected: "指定なし",
  m_cart_account: {
    title_create: "注文者の編集",
    cancel_message: "の編集内容を破棄します。この操作は取り消せません。",
    delete_message: "を削除します。",
  },
  my_page: {
    delivery_destination: {
      title: "納入先の登録",
      delete_message: "を削除します。",
    },
    changed_password: {
      updated: "パスワードを更新しました",
    },
  },
  common: {
    message: {
      created: "作成しました",
      updated: "更新しました",
      deleted: "削除しました",
      cancel_button: "はい",
      cancel_delete_button: "キャンセル",
      not_change_password: "パスワードが変更されていません",
    },
    buttons: {
      cancel: "キャンセル",
      yes: "はい",
      no: "いいえ",
    },
    cancel_message: "{name}の編集内容を破棄します。この操作は取り消せません。",
    delivery_no_selected: "納入先を選択してください",
  },
  login: {
    required: {
      login_id_and_password: "ログインIDとパスワードを入力してください",
      login_id: "ログインIDを入力してください",
      password: "パスワードを入力してください",
    },
  },
  admin: {
    title_create: "社内利用者の新規作成",
    title_edit: "{name}の編集",
  },
};
